import { useScrollReveal } from '../hooks/useScrollReveal';

const dirClass = {
  up: 'reveal',
  left: 'reveal-left',
  right: 'reveal-right',
  scale: 'reveal-scale',
};

export function Reveal({ children, direction = 'up', delay = 0, className = '' }) {
  const [ref, isVisible] = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`${dirClass[direction] || 'reveal'} ${isVisible ? 'visible' : ''} ${
        delay ? `stagger-${delay}` : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}
